var React = require('react');

function ArrowLeftLarge (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"m8.5 1.25-7.25 7.5 7.25 7.5M23.5 8.75H1.25"})));
}

ArrowLeftLarge.defaultProps = {"width":"24.75","height":"17.5","data-name":"Layer 1","viewBox":"0 0 24.75 17.5"};

module.exports = ArrowLeftLarge;

ArrowLeftLarge.default = ArrowLeftLarge;
